export default __webpack_public_path__ + "static/media/5.c2df5719.svg";